import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const TITLE_CLASS_NAME = 'Title';
export const TITLE_CLASS_SLOTS = [
	'root',
	'icon',
	'iconArea',
	'titleArea',
] as const;

export type TitleClassSlot = typeof TITLE_CLASS_SLOTS[number];

export interface TitleClasses {
	root: string;
	icon: string;
	iconArea: string;
	titleArea: string;
}

export type TitleClassKey = keyof TitleClasses;

export const getTitleUtilityClass = (slot: string) =>
	generateUtilityClass(TITLE_CLASS_NAME, slot as TitleClassSlot);

export const titleClasses: TitleClasses = generateUtilityClasses(
	TITLE_CLASS_NAME,
	['root', 'icon', 'iconArea', 'titleArea'],
);

export default titleClasses;
